export class WeatherGraphValues {
    dewPointValues: number[] = [];
    windValues: number[] = [];
    temperatureValues: number[] = [];
    precipitationValues: number[] = [];
    solarRadiationValues: number[] = [];
    relativeHumidityValues: number[] = [];
}
